<template>
  <div class="mt-2 card">
    <h3 class="font-grey kne-title">{{$t('Dashboard.update.title')}}</h3>
    <div class="w-100 container pb-2">
      <div v-for="(update, index) in updateList.transporter" :key="index" class="m-2 mb-5 w-100 update-container">
        <h3>{{update.title}}</h3>
        <span class="devNote"><i>{{$t('Dashboard.update.dev-notes')}}: "{{update.devNote}}"</i></span>
        <span class="devNote update-dateText mt-3"><i>{{formatDate(update.creationDate)}}</i></span>
        <hr class="hrLine mt-0 w-100">
        <span>{{update.description[getLanguage]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '../../../../firebase.js'

export default {
  data () {
    return {
      updateList: []
    }
  },

  async created () {
    await this.loadNewUpdateList()
    this.$forceUpdate()
  },

  methods: {
    async loadNewUpdateList () {
     await db.ref().child('updates').child('transporter').once('value').then((data) => {
      this.updateList[data.key] = data.val()
     })
    },

    formatDate (date) {
      var formattedDate = new Date(date)
      return formattedDate.getFullYear() + '-' + ('0' + (formattedDate.getMonth() + 1)).slice(-2) + '-' + ('0' + formattedDate.getUTCDate()).slice(-2)
    }
  },

  computed: {
    getLanguage () {
      return this.$store.state.userInfo.language
    }
  }
}
</script>

<style scoped>
  .update-container {
    display: flex;
    flex-flow: column;
  }
  .devNote {
    color: rgb(70, 70, 70);
  }
  .update-dateText {
    font-size: 0.8rem;
  }
  .hrLine {
    border: 1px rgba(172, 172, 172, 0.386) solid;
  }
  .description {
    background-color: rgb(222, 222, 222);
  }
</style>
